import { render, staticRenderFns } from "./AreaIndex.vue?vue&type=template&id=13462b04&scoped=true"
import script from "./AreaIndex.vue?vue&type=script&lang=js"
export * from "./AreaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13462b04",
  null
  
)

export default component.exports